import { IGetters } from './getters.types'

export const getters: IGetters = {

}